import * as CL from '@design-system/component-library';
import { getFilterKeys, getSelectedFilterCount } from '../../common/utils/productListUtilsCoCo.js';
import { FilterTag } from '../FilterTag/FilterTag.js';
import type { Filters } from './ProductGridFilterCoCo.js';

interface ProductGridFilterTagsCoCoProps<T> {
  filters: Filters<T>;
  setFilters: (filters: Filters<T>) => void;
}

export const ProductGridFilterTagsCoCo = <T,>({ filters, setFilters }: ProductGridFilterTagsCoCoProps<T>) => {
  if (getSelectedFilterCount(filters) === 0) {
    return null;
  }

  const removeFilter = (key: keyof Filters<T>, option: string) =>
    setFilters({
      ...filters,
      [key]: {
        ...filters[key],
        selectedOptions: filters[key].selectedOptions.filter(value => value !== option),
      },
    });

  return (
    <CL.Grid className="of-product-grid__filter-tags">
      <CL.GridRow>
        <div className="of-product-grid__filter-tags-container">
          {getFilterKeys(filters).map(key =>
            filters[key].selectedOptions.map(option => (
              <FilterTag
                key={`${key}-${option}`}
                subcategory={key}
                label={option}
                onRemoveFilter={() => removeFilter(key, option)}
              />
            ))
          )}
        </div>
      </CL.GridRow>
    </CL.Grid>
  );
};
